import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';
import type * as React from 'react';

export type PillTone = 'warning' | 'danger' | 'success';

const pillStyle = (tone: PillTone) => css`
	display: inline-flex;
	align-items: center;
	padding: 0.125rem 0.625rem;
	border-radius: ${theme.radii.pill};
	background-color: ${theme.states[tone].surface};
	color: ${theme.states[tone].ink};
	font-family: ${theme.fonts.body};
	font-size: ${theme.fontSizes.small};
	font-weight: ${theme.fontWeights.semibold};
	line-height: 1.4;
	white-space: nowrap;
`;

type Props = {
	readonly text: string;
	readonly tone: PillTone;
};

/** A one-line pill painted with the whole surface + ink pair of a state. */
const TonePill: React.FC<Props> = ({ text, tone }) => {
	return <span css={pillStyle(tone)}>{text}</span>;
};

export default TonePill;
